import { api } from './base';

import { MutationArg, Pageable } from 'v2/types';
import { SWRKeyPagination, SWRKeyValue } from 'v2/types/swr';
import { VideoModel, VideoForm } from 'v2/types/VideoModel';

export const videoService = {
  getVideos([_key, page, limit]: SWRKeyPagination): Promise<Pageable<VideoModel>> {
    return api
      .get('v1/admin/video', { searchParams: { page, limit, sortFields: JSON.stringify({ order: 'asc' }) } })
      .json();
  },

  createVideo(_key: string, { arg }: MutationArg<VideoForm>): Promise<VideoModel> {
    return api.post('v1/admin/video', { json: arg }).json();
  },

  changeVideoOrder(_key: string, { arg }: MutationArg<Pick<VideoModel, 'id' | 'order'>[]>): Promise<VideoModel> {
    return api.patch('v1/admin/video/order', { json: arg }).json();
  },

  updateVideo([_key, videoId]: SWRKeyValue, { arg }: MutationArg<VideoForm>): Promise<VideoModel> {
    return api.put(`v1/admin/video/${videoId}`, { json: arg }).json();
  },

  deleteVideo([_key, videoId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/video/${videoId}`).json();
  },
};
